import React, { useCallback, useEffect, useState } from "react";
import MainLayout from "../../components/layouts/MainLayout";
import { DeleteFilled, EditFilled, EyeFilled } from "@ant-design/icons";
import { providerApi } from "../../api/providerApi";
import { Auth } from "../../utils/Auth";
import { message, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { appointmentApi } from "../../api/appointmentsApi";

const ListAppointmentsView = () => {
    const token = Auth.getSessionToken()
    const abortController = new AbortController()
    const [appointments, setAppointments] = useState([])
    const [loading, setLoading] = useState(false)
    const [totalPages, setTotalPages] = useState(1);
    const navigate = useNavigate()
    const itemsPerPage = 15
    const [currentPage, setCurrentPage] = useState(1)


    const handlefetchdata = async () => {
        setLoading(true)

        try {
            const res = await appointmentApi.getRdvs(abortController.signal, {
              page: currentPage, // Page actuelle
              limit: 10,        // Nombre d'éléments par page
          },)
 
            if(!res){
                setLoading(false)
                   return;

            }            
            
            setAppointments(res.data)
            setTotalPages(res.data.totalPages);
            setLoading(false)
            console.log("rdv",appointments)
 
         } catch (error) {
             console.log(error)
            setLoading(false)
 
         }
    }

    const handleDetail = (appointment) => {
        console.log("ID rdv",appointment.id)
        if(appointment.id)
            return navigate(`/gestion-rdv/${appointment.id}/details`)
        
    }

   
   
    const handleDelete = async (appointment) => {
        try {
          const res = await providerApi.deleteProvider(`${appointment.id}`,abortController.signal)

          if (res) {
            message.success("Les informations ont été mises à jour avec succès !");
          }

          handlefetchdata()
          
        } catch (error) {
          console.error(error);
          setLoading(false);
          message.error("Échec de suppression des informations");
        }
        
        

    }
    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = appointments.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    useEffect(() => {
        handlefetchdata()

        console.log('liste get token',token)
    },[currentPage])

  return (
    <MainLayout>
      <div className="container mx-auto p-4">
        <h1 className="text-xl font-bold mb-4">Liste des Rendez-vous</h1>

       

        {/* Table */}
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="py-2 px-4 border-b text-left">#</th>
              <th className="py-2 px-4 border-b text-left">Date rendez-vous</th>
              <th className="py-2 px-4 border-b text-left">Horaire</th>
              <th className="py-2 px-4 border-b text-left">Client</th>
              <th className="py-2 px-4 border-b text-left">Prestataire</th>
              <th className="py-2 px-4 border-b text-left">Status</th>
              <th className="py-2 px-4 border-b text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
                <tr>
                <td colSpan="6" className="text-sm text-center py-4">
                    Chargement des données en cours...
                </td>
                </tr>
            ) : (
              currentItems.map((appointment, index) => (
                <tr key={appointment.id}>
                    <td className="py-2 px-4 border-b">{index + 1}</td>
                    <td className="py-2 px-4 border-b">
                    {appointment?.date_rdv} 
                    </td>
                    <td className="py-2 px-4 border-b">{appointment?.hour_start_rdv} - {appointment?.hour_end_rdv}</td>
                    <td className="py-2 px-4 border-b">{appointment?.client?.lastname} {appointment?.client?.name}</td>
                    <td className="py-2 px-4 border-b">{appointment?.mecanicien?.lastname} {appointment?.mecanicien?.name}</td>
                    <td className="py-2 px-4 border-b">
                        {appointment?.status === null ? <span className="bg-blue-700 text-white text-sm p-2 rounded-lg">En attente</span> 
                        : appointment?.status === "ACCEPTED" ? <span className="bg-green-700 text-white text-sm p-2 rounded-lg">Accepte</span> 
                        : <span className="bg-red-700 text-white text-sm p-2 rounded-lg">Refuse</span> }
                    </td>
                    <td className="py-2 px-4 border-b">
                    <EyeFilled
                        className="text-green-600 mr-2 cursor-pointer hover:text-green-800"
                        onClick={() => handleDetail(appointment)}
                    />
                    
                    <DeleteFilled className="text-red-600 cursor-pointer hover:text-red-800"
                      onClick={() => handleDelete(appointment)}
                    />
                    </td>
                </tr>
                ))
            )}
            </tbody>

        </table>
        <div className="flex ml-0 space-x-2 mt-2 justify-end">
                    {Array.from({ length: Math.ceil(appointments.length / itemsPerPage) }, (_, i) => (
                        <button 
                            key={i} 
                            onClick={() => paginate(i + 1)}
                            className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
      </div>
    </MainLayout>
  );
};

export default ListAppointmentsView;
